
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import { Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { withAuth } from '../../api/withAuth';
import {
    useAuth

} from '../../contexts/authContext';

const GoldFinderApi = withAuth(axios.create({
    baseURL: process.env.REACT_APP_GOLD_FINDER_API_URL
    //baseURL: "http://localhost:3000"

}))


export const AddMultiplerModal = (props) => {

    const [anumber, setAnumber] = useState();
    const [multiplier, setMultiplier] = useState();
    const [desc, setDesc] = useState();
    const [surfaceSampleType, setSurfaceSampleType] = useState();
    const [surfaceSampleTypes, setSurfaceSampleTypes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (props.show) {
            fetchSurfaceSampleTypes();
            // Reset form when modal opens
            setAnumber('');
            setMultiplier(0.001);
            setDesc('');
            setSurfaceSampleType('');
            setError('');
        }
    }, [props.show]);

    const fetchSurfaceSampleTypes = async () => {
        try {
            const response = await GoldFinderApi.get('/admin/surface-sample-types');
            setSurfaceSampleTypes(response.data.surfaceSampleTypes);
        } catch (error) {
            console.error('Error fetching surface sample types:', error);
        }
    };


    const storeReport = async () => {
        setLoading(true);
        setError('');
        
        try {
            const data = {
                anumber: anumber,
                multiplier: multiplier,
                description: desc,
                surfacesampletype: surfaceSampleType
            };
            
            const response = await GoldFinderApi.post("/admin/modifiers/soils", {
                data
            });

            if (response.data.done) {
                props.onHide();
                
                // Refresh the table data if callback provided
                if (props.onSuccess) {
                    props.onSuccess();
                }
                
                // reset values back to default
                setAnumber('');
                setMultiplier(0.001);
                setDesc('');
                setSurfaceSampleType('');
            }
        } catch (error) {
            console.error('Error creating modifier:', error);
            
            if (error.response && error.response.status === 409 && error.response.data.isDuplicate) {
                setError(error.response.data.error);
            } else {
                setError('Failed to create modifier. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    }


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Add Modifier
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && (
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                )}
                <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                >
                    <Form.Label>A Number</Form.Label>
                    <Form.Control type="number"
                        value={anumber}
                        onChange={e => setAnumber(e.target.value)} />
                </Form.Group>
                <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                >
                    <Form.Label>Multipler</Form.Label>
                    <Form.Control type="number"
                        step="0.001"
                        value={multiplier}
                        onChange={e => setMultiplier(e.target.value)} />
                </Form.Group>
                <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                >
                    <Form.Label>Surface Sample Type</Form.Label>
                    <Form.Select
                        value={surfaceSampleType}
                        onChange={e => setSurfaceSampleType(e.target.value)}
                    >
                        <option value="">Select type...</option>
                        {surfaceSampleTypes.map(type => (
                            <option key={type.surfacesampletypeid} value={type.surfacesampletypeid}>
                                {type.nicename}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
                <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                >
                    <Form.Label>Description</Form.Label>
                    <Form.Control type="text"
                        value={desc}
                        onChange={e => setDesc(e.target.value)} />
                </Form.Group>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="pull-left" onClick={props.onHide} disabled={loading}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={() => storeReport()} disabled={loading}>
                    {loading ? 'Adding...' : 'Add'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}